import { LoggerOptions } from "pino";

import { LogLevel, Logger } from "../logger";

export function useLogger(options?: LoggerOptions) {
  const logger = new Logger({ ...options, level: LogLevel.DEBUG });

  return {
    logger,
  };
}
